import { Component, computed, effect, input, output, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'vectronic-single-device-selector',
  templateUrl: './single-device-selector.component.html',
  styleUrls: ['./single-device-selector.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class SingleDeviceSelectorComponent {
  allDeviceIds = input<number[]>(null);
  selectedId = input<number | null>(null);

  selectedIdChangeEvent = output<number | null>();

  value = signal('');

  private allIdsSet = computed(() => new Set((this.allDeviceIds() as number[]) ?? []));
  filteredOptions = computed(() => {
    const v = this.value().trim();
    const ids = (this.allDeviceIds() as number[]) ?? [];
    if (!v || v.length < 2) return [] as number[];
    const numStr = v.match(/\d+/)?.[0];
    if (!numStr) return [] as number[];
    return ids.filter((id) => String(id).includes(numStr)).slice(0, 50);
  });

  constructor() {
    effect(() => {
      const id = this.selectedId();
      if (id == null) {
        this.value.set('');
      } else {
        this.value.set(String(id));
      }
    });
  }

  onOptionSelected(id: number) {
    this.value.set(String(id));
    this.selectedIdChangeEvent.emit(id);
  }

  onEnter() {
    const txt = this.value().trim();
    if (!txt) {
      this.clear();
      return;
    }
    const id = Number(txt.match(/\d+/)?.[0] ?? NaN);
    if (Number.isFinite(id) && this.allIdsSet().has(id)) {
      this.selectedIdChangeEvent.emit(id);
    } else {
      // keep text but do not emit invalid id
    }
  }

  clear() {
    this.value.set('');
    this.selectedIdChangeEvent.emit(null);
  }

  isInvalid() {
    const txt = this.value().trim();
    if (!txt) return false;
    const id = Number(txt.match(/\d+/)?.[0] ?? NaN);
    return !(Number.isFinite(id) && this.allIdsSet().has(id));
  }
}
